import { render, staticRenderFns } from "./PlatformShowcase.vue?vue&type=template&id=13bc6196&scoped=true"
import script from "./PlatformShowcase.vue?vue&type=script&lang=js"
export * from "./PlatformShowcase.vue?vue&type=script&lang=js"
import style0 from "./PlatformShowcase.vue?vue&type=style&index=0&id=13bc6196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bc6196",
  null
  
)

export default component.exports